module.exports = __webpack_public_path__ + "img/Exhibition_Logo.bf2506b9.jpg";